import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0f7957"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"24px","margin-bottom":"24px","margin-left":"10px"} }, " 装修、采购协议审核 ", -1))
const _hoisted_2 = { class: "decoration-agreement-applyDetail" }
const _hoisted_3 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { decproChangeDetail } from "@/api/change_process";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false },
    traceId: { default: "" }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean, traceId: string }





watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

onMounted(async () => {
  getdata();
});

const getdata = async () => {
  const { Data } = await decproChangeDetail({
    Id: props.folwId,
    TraceId: props.traceId,
  });
  tableData.value = [
    ...((Data?.PageFiles.length > 0 && Data?.PageFiles) || []),
    ...((Data?.BackPageFiles.length > 0 && Data?.BackPageFiles) || []),
  ];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "租赁合同审核",
      style: {"margin-top":"24px"}
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})